<template>
  <div class="sub_detail">
    <header class="n-fixed-top bg-c bColor" v-if="is_webview == 0">
      <div class="left" v-if="$route.name !== 'index'" @click="back()">
        <!--<router-link to="/main/index"  class="n-back"></router-link>-->
        <div class="n-back"></div>
      </div>
      <h4>
        <span>{{ $t("Practice_tool_report.report") }}</span>
      </h4>
      <div class="right" v-if="$route.name !== 'index'"></div>
    </header>
    <div class="sr_con">
      <div class="logo">
        <img :src="company.logo ? company.logo : defaultHeadImg" alt="" />
      </div>
      <div class="sr_tit">{{ subDoDetailData.follow_up.name }}</div>
      <div class="sr_des sr_sx">
        {{ $t("Practice_tool_report.Item_name") }}
        <span> {{ subDoDetailData.follow_up_detail[0].practice_name }}</span>
      </div>
      <div class="sr_des sr_name">
        {{ $t("Practice_tool_report.Student_Name") }}
        <span> {{ subDoDetailData.user.username }}</span>
      </div>
      <div class="sr_des sr_time">
        {{ $t("Practice_tool_report.Submission_time") }}
        <span>{{ subDoDetailData.follow_up_detail[0].created_at }} </span>
      </div>
      <!-- <div class="sr_des sr_que">请结合本模块学到的面试前准备、面试中提问等选聘技巧，反思你
          参与的最不成功的一场招聘面试。</div>-->
      <div class="sr_des" v-for="(item, index) in questionList" :key="index">
        <p>{{ index + 1 }}.{{ item.question_title }}</p>
        <p v-html="$xss(item.question_content)"></p>
        <div class="sr_des_con" v-if="item.question_type == 5">
          {{ item.answer_arr.input_value }}
        </div>
      </div>
      <!--  <div class="sr_des" v-if="subDoDetailData.follow_up_detail[0].behavior_type==1">
            <p>1.情境</p>
            <p>请具体描述这个面试的背景，如招聘职位、任职要求等。</p>
            <div class="sr_des_con">
              容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容。
            </div>
          </div> -->
    </div>
  </div>
</template>
<script>
import defaultHeadImg from "@/assets/img/new/logo.png";
export default {
  data() {
    return {
      titleValue: this.$t("Practice_tool_report.Case_analysis"),
      defaultHeadImg: defaultHeadImg,
      user_follow_up_detail_id: "", //
      subDoDetailData: [], // 下属案例详情列表数据
      company: {}, // 公司信息
      questionList: [], // 问题列表
      is_webview: 0, // 0 ：h5, 1:安卓iOS
    };
  },
  mounted() {
    // document.title=this.$t('Practice_tool_report.report');
    this.$nextTick(() => {
      this.user_follow_up_detail_id =
        this.$route.query.user_follow_up_detail_id;
      this.getSubReflectDetailDate();
    });
  },
  methods: {
    getSubReflectDetailDate() {
      var _this = this;
      let url = "index.php/mobile/user-follow-up/practice-report";

      let webview = {},
        params = {};
      window.location.hash
        .split("?")[1]
        .split("&")
        .forEach((e) => {
          let arr0 = e.split("=")[0];
          let arr1 = e.split("=")[1];
          webview[arr0] = arr1;
        });
      if (webview.is_webview == 1) {
        this.is_webview = 1;
        params = webview;
      } else {
        params = {
          user_id: localStorage.getItem("_user_data_id"),
          company_id: localStorage.getItem("_user_data_company_id"),
          sso_token: localStorage.getItem("_user_data_sso_token"),
          sys_id: localStorage.getItem("_sys_id"),
          language: localStorage.getItem("_user_data_language"),

          page: 1,
          size: 10,
          user_follow_up_detail_id: this.user_follow_up_detail_id,
        };
      }

      this.$axios.post(url, params).then(function (res) {
        // console.log(res.data.result)
        if (res.data.code == 0) {
          _this.subDoDetailData = res.data.result;
          _this.company = res.data.result.company;
          _this.questionList =
            res.data.result.follow_up_detail[0].survey.questions;
        }
      });
    },
    back() {
      this.$router.push({
        path: "/main/sub_index/sub_do",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sub_detail {
  background-color: #eee;
  min-height: 100vh;
  overflow: auto;
  .sr_con {
    margin: 0.32rem;
    min-height: calc(100% - 1.36rem);
    padding: 0.26rem 0.2rem;
    box-sizing: border-box;
    background-color: #fff;
    font-size: 0.22rem;
    color: #252631;
    border-radius: 0.1rem;
    .logo {
      img {
        width: 1.78rem;
        height: 0.4rem;
      }
    }
    .sr_tit {
      font-size: 0.26rem;
      margin-top: 0.34rem;
      margin-bottom: 0.58rem;
      text-align: center;
    }
    .sr_des {
      span {
        display: inline-block;
        width: 5rem;
        color: #7f8485;
        border-bottom: 0.02rem solid #dedede;
        vertical-align: top;
        margin-left: 0.1rem;
      }
      p {
        margin-bottom: 0.2rem;
      }
      .sr_des_con {
        width: 6.1rem;
        min-height: 0.4rem;
        border: 1px solid rgba(216, 216, 216, 0.85);
        border-radius: 0.04rem;
        margin-bottom: 0.32rem;
        padding: 0.2rem;
        color: #7f8485;
      }
    }
    .sr_sx {
      margin-top: 0.58rem;
    }
    .sr_name {
      margin-top: 0.1rem;
    }
    .sr_time {
      margin-top: 0.1rem;
      margin-bottom: 0.6rem;
    }
    .sr_que {
      margin-top: 0.6rem;
      margin-bottom: 0.3rem;
    }
  }
}
</style>
